<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  [formCtrl]="formCtrl"
  ctrlPlaceholder="Izaberite tip dokumenta"
></kodit-dropdown>
